import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../../utils/apolloClient';

const initialState = {
  acceptedLatestFortellisTerms: false,
  updateLatestFortellisTermsSuccess: null,
  isUpdateLatestFortellisTermsPending: null,
  errorInUpdateLatestFortellisTerms: false,
  isUpdateLatestFortellisTermsLoading: false,
  userEmail: ''
};

export const updateFortellisTerms = createAsyncThunk(
  'updateFortellisTerms',
  async ({ userEmail, accessToken }, thunkAPI) => {
    let response = await client.authorizeRequest({
      method: 'POST',
      url: '/update-fortellis-terms',
      headers: { authorization: `Bearer ${accessToken}` },
      data: {
        username: userEmail
      }
    });
    return response;
  }
);

export const updateFortellisTermsSlice = createSlice({
  name: 'updateFortellisTermsSlice',
  initialState,
  reducers: {
    setEmail: (state, action) => {
      state.userEmail = action.payload;
    }
  },
  extraReducers: {
    [updateFortellisTerms.fulfilled]: (state, action) => {
      const { acceptedUpdatedFortellisTerms } = action.payload.data;
      state.acceptedLatestFortellisTerms = acceptedUpdatedFortellisTerms;
      state.updateLatestFortellisTermsSuccess = true;
      state.isUpdateLatestFortellisTermsPending = false;
    },
    [updateFortellisTerms.pending]: (state, action) => {
      state.isUpdateLatestFortellisTermsPending = true;
      state.isUpdateLatestFortellisTermsLoading = true;
    },
    [updateFortellisTerms.rejected]: (state, action) => {
      state.updateLatestFortellisTermsSuccess = false;
      state.isUpdateLatestFortellisTermsPending = true;
      state.isUpdateLatestFortellisTermsLoading = false;
      state.errorInUpdateLatestFortellisTerms = action.error;
    }
  }
});

export const { setEmail } = updateFortellisTermsSlice.actions;

export default updateFortellisTermsSlice.reducer;